import styled from '@emotion/styled';
import Button from '@ep/components/Button';
import ContactFormMenu from '@ep/components/ContactForm/ContactFormMenu';
import SeeMoreLink from '@ep/components/SeeMoreLink';
import TextField from '@ep/components/TextField';
import { Body, Subhead2 } from '@ep/components/Typography';
import theme from '@ep/theme';
import React, { useState } from 'react';

interface formProps {
  type: string;
  data: object;
}
interface CardProps {
  setCardState: ({ header, icon, type, card }) => void;
  formState: formProps;
  setFormState: ({ type, data }) => void;
}

const CardContainer = styled.div`
  display grid;
  grid-template-columns: 1fr 4fr 1fr;
  grid-template-rows: 1fr 6fr 1fr;
  height: 100%;
`;

const Content = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-column: 2;
  grid-row: 2;
`;

const StyledSubhead = styled(Subhead2)`
  padding-right: 13rem;
  ${theme.mediaQueries.mobile} {
    padding: 1rem;
  }
`;

const StyledButton = styled(Button)`
  margin-top: 5rem;
`;

const StyledTextField = styled(TextField)`
  grid-column: 2;
  margin-top: 0.25rem;
  .MuiFilledInput-input {
    height: 30px;
  }
  .MuiFilledInput-multiline {
    height: 70px;
    padding: 0.25rem 0.5rem;
    .MuiFilledInput-input {
      height: 70px;
    }
  }
  ${theme.mediaQueries.mobile} {
    grid-column: 1;
  }
`;

// const StyledH2Medium = styled(H2Medium)`
//   margin-top: 1.5rem;
//   margin-bottom: 2rem;
// `;

const StyledBody = styled(Body)`
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.7rem;
  ${theme.mediaQueries.mobile} {
    font-size: 1.3rem;
  }
`;

const LinksContainer = styled('div')`
  max-width: 33rem;
  text-align: left;
`;

const StyledSeeMoreLink = styled(SeeMoreLink)`
  font-size: 1.5rem;
  font-family: ${theme.typography.primaryFont.light};
  color: ${theme.colors.oceanBlue};
  ${theme.mediaQueries.mobile} {
    font-size: 1.3rem;
  }
`;

const Form = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: ${theme.breakpoints.optimalMobile + 400}px) {
    margin-top: 1.5rem;
    display: block;
  }
`;

const CTCard2 = ({ setCardState, formState, setFormState }: CardProps) => {
  const [interest, setInterest] = useState('none');

  return (
    <CardContainer>
      <Content>
        <StyledBody>
          Please click the link below to go directly to our Support Center.
        </StyledBody>
        <LinksContainer>
          <StyledSeeMoreLink
            label="EP Support Center"
            to="https://www.ep.com/support/"
            // onClick={() => {
            //   dataLayer.push({
            //     event: 'Contact link click - ' + `EP Support Center`,
            //   });
            // }}
          />
          {/* <StyledSeeMoreLink
            label="Crew login page"
            to="https://www.ep.com/crew/"
            onClick={() => {
              dataLayer.push({
                event: 'Contact link click - ' + `Crew login page`,
              });
            }}
          />
          <StyledSeeMoreLink
            label="Get your historical pay information"
            to="https://www.ep.com/myep/"
            onClick={() => {
              dataLayer.push({
                event:
                  'Contact link click - ' +
                  `Get your historical pay information`,
              });
            }}
          />
          <StyledSeeMoreLink
            label="Get your W-2 online"
            to="https://entertainmentpartners.my.site.com/s/product-support?tabset-ca7f4=2"
            onClick={() => {
              dataLayer.push({
                event: 'Contact link click - ' + `Get your W-2 online`,
              });
            }}
          />
          <StyledSeeMoreLink
            label="Sign up for direct deposit"
            to="https://entertainmentpartners.my.site.com/s/product-support"
            onClick={() => {
              dataLayer.push({
                event: 'Contact link click - ' + `Sign up for direct deposit`,
              });
            }}
          />
          <StyledSeeMoreLink
            label="Background actors payroll, forms and FAQs"
            to="https://entertainmentpartners.my.site.com/s/product-support?tabset-ca7f4=3 "
            onClick={() => {
              dataLayer.push({
                event: 'Contact link click - ' + `Background Actors FAQs`,
              });
            }}
          />
          <StyledSeeMoreLink
            label="Crew & Talent payroll forms and top FAQs"
            to="https://entertainmentpartners.my.site.com/s/product-support?tabset-ca7f4=2"
            onClick={() => {
              dataLayer.push({
                event:
                  'Contact link click - ' +
                  `Crew & Talent Payroll Forms & top FAQ’s`,
              });
            }}
          />
          <StyledSeeMoreLink
            label="Benefit Solutions / EP Cares support"
            to="https://entertainmentpartners.my.site.com/s/benefit-solutions"
            onClick={() => {
              dataLayer.push({
                event:
                  'Contact link click - ' +
                  `Benefit Solutions / EP Cares support`,
              });
            }}
          /> */}
        </LinksContainer>
        <StyledBody>UK supporting artists, please click the link below.</StyledBody>
        <StyledSeeMoreLink
            label="UK Casting Contact"
            to="https://www.ep.com/uk-casting-community/contact-us/"
            // onClick={() => {
            //   dataLayer.push({
            //     event: 'Contact link click - ' + `UK Casting Contact`,
            //   });
            // }}
          />
        <StyledBody>For all other inquiries, continue below.</StyledBody>
        <StyledButton
          label="Continue"
          onClick={() => {
            // dataLayer.push({ event: 'Contact path - Crew And Talent' });
            // dataLayer.push({
            //   event:
            //     'Contact interest - Redirected to Salesforce PWE form (CREW AND TALENT)',
            // });
            window.location.href =
              'https://entertainmentpartners.my.salesforce-sites.com/PWEWeb/PWE_Web_IntakeForm';
            //setCardState({
            //  header: 'Crew and Talent Support',
            //  icon: 'CrewTalentSupport',
            //  type: 'CTCard',
            //  card: 3,
            //});
            //setFormState({
            //  ...formState,
            //  data: {
            //    ...formState.data,
            //    interest: interest,
            //  },
            //});
          }}
        />
      </Content>
    </CardContainer>
  );
};

const CTCard3 = ({ setCardState, formState, setFormState }: CardProps) => {
  const menuOptions = [
    {
      label: 'Employment verification',
      short: 'Employment verification',
      value: 'Employment verification',
    },
    {
      label: 'Payroll/payment/W-2',
      short: 'Payroll/payment/W-2',
      value: 'Payroll/payment/W-2 support',
    },
    {
      label: 'Benefit Solutions/EP Cares',
      short: 'Benefit Solutions/EP Cares',
      value: 'Benefit Solutions/EP Cares support',
    },
    {
      label: 'Central Casting',
      short: 'Central Casting support',
      value: 'Central Casting support',
    },
    {
      label: 'Other',
      short: 'Other',
      value: 'Other',
    },
  ];

  const [interest, setInterest] = useState('none');

  const highlightInterestField = () => {
    interest == 'none'
      ? (document.getElementById('crewAndTalentSupportInterestMenu').style =
          'border: 3px solid ' + theme.colors.mediumRed)
      : (document.getElementById(
          'contaccrewAndTalentSupportInterestMenutFormMenu',
        ).style = 'border: 1px solid ' + theme.colors.darkGray);
  };

  return (
    <CardContainer>
      <Content>
        <StyledSubhead>I'd like support with:*</StyledSubhead>
        <ContactFormMenu
          options={menuOptions}
          action={setInterest}
          menuId="crewAndTalentSupportInterestMenu"
        />
        <StyledButton
          label="Continue"
          onClick={() => {
            if (interest != 'none') {
              setCardState({
                header: 'Crew and Talent Support',
                icon: 'CrewTalentSupport',
                type: 'CTCard',
                card: 4,
              });
              setFormState({
                ...formState,
                data: {
                  ...formState.data,
                  interest: interest,
                  // START SALESFORCE FIELDS
                  subject: 'EP.com Request - ' + interest,
                  // END SALESFORCE FIELDS
                },
              });
            } else {
              highlightInterestField();
            }
          }}
        />
      </Content>
    </CardContainer>
  );
};

const CTCard4 = ({ setCardState, formState, setFormState }: CardProps) => {
  interface InfoProps {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    memo: string;
  }

  const [infoData, setInfoData] = useState<InfoProps>({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    memo: '',
  });

  const highlightField = (fieldName) => {
    !infoData[fieldName]
      ? (document.getElementsByName(fieldName)[0].style =
          'border: 3px solid ' + theme.colors.mediumRed)
      : (document.getElementsByName(fieldName)[0].style =
          'border: 0px solid white');
  };

  const highlightEmail = () => {
    document.getElementsByName('email')[0].style =
      'border: 3px solid ' + theme.colors.mediumRed;
  };

  const handleBlur = (event) => {
    const { name } = event.target;
    highlightField(name);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInfoData({ ...infoData, [name]: value });
  };

  const handleSubmit = () => {
    var email = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    if (email.test(infoData.email)) {
      if (
        infoData.firstName &&
        infoData.lastName &&
        infoData.email &&
        infoData.memo
      ) {
        setFormState({
          // START SALESFORCE FIELDS
          ...formState,
          data: {
            ...formState.data,
            debug: '0',
            debugEmail: 'mgalletti@ep.com',
            orgid: '00Di0000000g6Hf',
            retURL: 'https://www.ep.com/thank-you/',
            name: infoData.firstName + ' ' + infoData.lastName,
            email: infoData.email,
            '00Ni000000GGP1o': infoData.phone,
            description: infoData.memo,
            case_origin: 'Website Contact Us',
            // END SALESFORCE FIELDS
          },
        });
        setCardState({
          header: `Thank You`,
          icon: '',
          type: 'submitting',
          card: 1,
        });
      } else {
        highlightField('firstName');
        highlightField('lastName');
        highlightField('email');
        highlightField('memo');
      }
    } else {
      highlightEmail();
    }
  };

  return (
    <CardContainer>
      <Content>
        <Form>
          <Subhead2 style={{ gridColumn: 1 }}>First name:*</Subhead2>
          <StyledTextField
            name="firstName"
            value={infoData.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Subhead2 style={{ gridColumn: 1 }}>Last name:*</Subhead2>
          <StyledTextField
            name="lastName"
            value={infoData.lastName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Subhead2 style={{ gridColumn: 1 }}>Email:*</Subhead2>
          <StyledTextField
            name="email"
            value={infoData.email}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Subhead2 style={{ gridColumn: 1 }}>Phone:</Subhead2>
          <StyledTextField
            name="phone"
            value={infoData.phone}
            onChange={handleChange}
          />
          <Subhead2 style={{ gridColumn: 1 }}>
            Tell us how we can help:*
          </Subhead2>
          <StyledTextField
            multiline
            rows={3}
            name="memo"
            value={infoData.memo}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Form>
        <StyledButton label="Submit" onClick={handleSubmit} />
      </Content>
    </CardContainer>
  );
};

export { CTCard2, CTCard3, CTCard4 };
